import React, { Fragment } from 'react';
import { Grid, Radio, RadioGroup, FormControlLabel, Box } from '@mui/material';
import ChatBubble from '@mui/icons-material/ChatBubble';

import Edit from '@mui/icons-material/Edit';
import { NewsSuggestionResult } from '../Component/NewsSuggestionResult';
import { toneOptions, dialetOptions } from '../../Inputs/constant';
import ActionButton from '../../ActionButton/ActionButton';
import SwitchToggle from '../../../../SwitchToggle';
import { TextField } from '@mui/material';
import RandomDataWarning from '../../Display/RandomDataWarning';
import FormLabelWithIcon from '../../Inputs/FormLabelWithIcon';
import { multilineTextInputSx } from '../../Inputs/inputStyles';

export const NewsMatchingView = props => {
  const { intl, news, options, onValueChange, onGenerate, classes } = props;
  const { tone, emoji, freeText, dialect, dialet } = options || {};
  const dialectValue = dialect ?? dialet ?? '';
  const toneValue = tone == null ? '' : String(tone);

  return (
    <Fragment>
      <Grid className={classes?.sectionContainer || ''}>
        <FormLabelWithIcon
          iconName="MessageSquare"
          labelText={intl.formatMessage({ id: 'gpt-icebreaking-message-style-dialect-title-v2' })}
          type="purple"
        />
        <RadioGroup
          row
          aria-label="gpt-message-rewrite-dialet"
          name="targeted-message-dialet"
          value={dialectValue}
          onChange={event => onValueChange('dialect', event.target.value)}
        >
          {dialetOptions.map((option, index) => (
            <FormControlLabel
              key={option.value + index}
              value={option.value}
              control={
                <Radio
                  color="primary"
                  className={classes.radioOption}
                  style={{ paddingTop: '2px', paddingBottom: '2px' }}
                />
              }
              label={intl.formatMessage({ id: option.label })}
            />
          ))}
        </RadioGroup>
      </Grid>

      <Grid className={classes?.sectionContainer || ''}>
        <FormLabelWithIcon
          iconName="Smile"
          labelText={intl.formatMessage({ id: 'gpt-message-rewrite-targeted-message-tone-title' })}
          type="green"
        />
        <RadioGroup
          row
          aria-label="tone"
          name="tone"
          value={toneValue}
          onChange={event => onValueChange('tone', event.target.value)}
        >
          {toneOptions.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              value={value}
              control={
                <Radio
                  color="primary"
                  className={classes.radioOption}
                  style={{ paddingTop: '2px', paddingBottom: '2px' }}
                />
              }
              label={intl.formatMessage({ id: label })}
            />
          ))}
        </RadioGroup>
      </Grid>

      <Grid className={classes?.sectionContainer || ''}>
        <FormLabelWithIcon
          iconName="Laugh"
          labelText={intl.formatMessage({ id: 'gpt-message-rewrite-tone-emoji' })}
          type="orange"
        />
        <SwitchToggle
          checked={!!emoji}
          ariaLabel="emoji"
          name="emoji"
          onChange={event => onValueChange('emoji', event.target.checked, emoji)}
        />
      </Grid>

      <Grid className={classes?.sectionContainer || ''}>
        <FormLabelWithIcon
          iconName="FileText"
          labelText={intl.formatMessage({ id: 'gpt-icebreaking-other-client-info-title-v2' })}
          type="blue"
        />
        <Box style={{ width: '100%' }}>
          <TextField
            variant="outlined"
            placeholder={intl.formatMessage({ id: 'gpt-news-matching-free-text-placeholder' })}
            fullWidth
            multiline
            rows={2}
            value={freeText}
            onChange={event => onValueChange('freeText', event.target.value, '')}
            slotProps={{ input: { sx: multilineTextInputSx } }}
          />
        </Box>
      </Grid>

      <Grid className={classes?.sectionContainer || ''}>
        <RandomDataWarning intl={intl} />
      </Grid>

      <Grid className={classes?.sectionContainer || ''}>
        <ActionButton onClick={onGenerate}>{intl.formatMessage({ id: 'gpt-message-generate-cta' })}</ActionButton>
      </Grid>

      {news &&
        news.map((item, index) => (
          <Grid key={item.newsID} className={classes?.sectionContainer || ''}>
            <Box
              style={{
                width: '100%',
                maxWidth: '100%',
                height: 'fit-content',
                border: '1px solid #B7B7B7',
                borderRadius: '2px',
                padding: '8px 12px'
              }}
            >
              <NewsSuggestionResult news={item} onGenerate={onGenerate} />
            </Box>
          </Grid>
        ))}
    </Fragment>
  );
};
